import React, { useState, ReactNode, ReactElement, CSSProperties } from 'react'
import { Icon } from '../../../components/Icon'

interface AccordionItemProps {
  title: string
  isActive: boolean
  onClick?: () => void
  children?: ReactNode
  AccordionItemStyleContainer?: CSSProperties
  AccordionItemStyle?: CSSProperties
  AccordiontitleStyle?: string
  icon?: string
  iconStroke?: string
  iconStrokeWidth?: number
  iconSize?: number
  rightIcon?: string
  bagdeLabel?: string
  badgeColor?: string
}

const AccordionItem: React.FC<AccordionItemProps> = ({
  title,
  isActive,
  onClick,
  children,
  AccordionItemStyleContainer,
  AccordionItemStyle,
  AccordiontitleStyle,
  icon,
  iconStroke,
  iconStrokeWidth,
  iconSize,
  rightIcon,
  bagdeLabel,
  badgeColor,
}) => {
  return (
    <div
      style={AccordionItemStyleContainer}
      className="w-[100%] rounded-[16px] border"
    >
      <button
        style={AccordionItemStyle}
        className={`w-full ${isActive ? 'rounded-t-[16px]' : 'rounded-[16px]'} h-[48px] bg-text8 flex justify-between items-center py-4 px-6 text-left focus:outline-none`}
        onClick={onClick}
      >
        <div className="flex items-center w-full gap-2">
          <div className="flex-1 flex gap-2 items-center">
            {icon && (
              <Icon
                name={icon}
                strokeWidth={iconStrokeWidth ? iconStrokeWidth : 1}
                stroke={iconStroke ? iconStroke : '#02698C'}
                width={iconSize ? iconSize : 16}
                height={iconSize ? iconSize : 16}
              />
            )}
            <p
              className={`${AccordiontitleStyle ? AccordiontitleStyle : 'text-sm leading-6 font-semibold text-text2'}`}
            >
              {title}
            </p>
            {rightIcon && (
              <Icon
                name={rightIcon}
                stroke={'#02698C'}
                strokeWidth={1}
                width={16}
                height={16}
              />
            )}
          </div>
          {bagdeLabel && (
            <div className={`${badgeColor} rounded-[40px] px-3 py-[6px]`}>
              <p className="text-xs font-medium leading-5 text-text2">
                {bagdeLabel}
              </p>
            </div>
          )}

          <Icon
            name={isActive ? 'IconChevronUp' : 'IconChevronDown'}
            stroke={'#02698C'}
            width={16}
            height={16}
          />
        </div>
      </button>
      {isActive && <div className="px-4">{children}</div>}
    </div>
  )
}

interface AccordionProps {
  children?: ReactNode
  defaultActiveIndex?: number | null | undefined
  onClick?: () => void
}

const Accordion: React.FC<AccordionProps> = ({
  children,
  defaultActiveIndex,
  onClick,
}) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(
    defaultActiveIndex ? defaultActiveIndex : 0
  )

  const handleItemClick = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index)
  }

  return (
    <div onClick={onClick} className="w-full flex flex-col gap-[20px] mx-auto">
      {React.Children.map(children, (child, index) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child as ReactElement, {
            isActive: activeIndex === index,
            onClick: () => handleItemClick(index),
          })
        }
        return null
      })}
    </div>
  )
}

export { Accordion, AccordionItem }
